import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const hdr = () => { const t = localStorage.getItem("admin_token"); return t ? { Authorization: `Bearer ${t}` } : {}; };

const urlB64ToUint8Array = (base64) => {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = window.atob((base64 + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;
// iPhone: push only works when the admin panel is installed on the Home screen
export const iosNeedsInstall = () => isIos() && !isStandalone();

export const deviceLabel = () => {
  const ua = navigator.userAgent;
  if (/iphone/i.test(ua)) return "iPhone";
  if (/ipad/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) return "iPad";
  if (/android/i.test(ua)) return /mobile/i.test(ua) ? "Android" : "Tablet Android";
  if (/windows/i.test(ua)) return "PC Windows";
  if (/macintosh/i.test(ua)) return "Mac";
  return "Dispositivo";
};

export const getPushSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  return (await reg?.pushManager.getSubscription()) || null;
};

export const savePushSubscription = async (sub, kinds = [], label = "") => {
  const raw = sub.toJSON();
  await axios.post(`${API}/admin/notifications/subscribe`, { endpoint: raw.endpoint, keys: { p256dh: raw.keys.p256dh, auth: raw.keys.auth }, kinds, label }, { headers: hdr() });
};

export const enablePush = async (kinds = []) => {
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso negato dal browser: abilita le notifiche nelle impostazioni del telefono per questo sito.");
  const { data } = await axios.get(`${API}/admin/notifications/vapid-public-key`, { headers: hdr() });
  if (!data.key) throw new Error("Chiave server mancante");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64ToUint8Array(data.key) }));
  await savePushSubscription(sub, kinds, deviceLabel());
  return sub;
};

export const disablePush = async () => {
  const sub = await getPushSubscription();
  if (!sub) return;
  await axios.delete(`${API}/admin/notifications/subscribe`, { headers: hdr(), params: { endpoint: sub.endpoint } });
  await sub.unsubscribe();
};

export const fetchSubscriptionPrefs = async (sub) =>
  axios.get(`${API}/admin/notifications/subscription`, { headers: hdr(), params: { endpoint: sub.endpoint } }).then((r) => r.data);

export const sendTestPush = () => axios.post(`${API}/admin/notifications/test`, {}, { headers: hdr() });
